function SintMaarten({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2105)">
  <path d="M14.6087 17.3913C14.6087 17.3913 4.69565 4.68406 4.68628 4.68631C7.58165 1.79088 11.5817 0 16 0C24.8365 0 32 7.1635 32 16L14.6087 17.3913Z" fill="#D80027"/>
  <path d="M14.6087 16C14.6087 16 4.69565 27.3159 4.68628 27.3137C7.58165 30.2091 11.5817 32 16 32C24.8365 32 32 24.8365 32 16H14.6087Z" fill="#0052B4"/>
  <path d="M4.68628 4.68652C-1.56209 10.9349 -1.56209 21.0656 4.68628 27.314C7.26834 24.732 9.75165 22.2486 16 16.0003L4.68628 4.68652Z" fill="#F0F0F0"/>
  <path d="M1.75382 16C1.74507 16.1149 1.73914 16.2306 1.73914 16.3477C1.73914 18.845 3.76364 20.8695 6.26088 20.8695C8.75813 20.8695 10.7826 18.845 10.7826 16.3477C10.7826 16.2306 10.7767 16.1148 10.7679 16H1.75382Z" fill="#FFDA44"/>
  <path d="M6.26094 13.9135C7.02934 13.9135 7.65225 13.2906 7.65225 12.5222C7.65225 11.7538 7.02934 11.1309 6.26094 11.1309C5.49254 11.1309 4.86963 11.7538 4.86963 12.5222C4.86963 13.2906 5.49254 13.9135 6.26094 13.9135Z" fill="#FFDA44"/>
  <path d="M3.13049 12.1738V16.6956C3.13049 19.0918 6.26093 19.826 6.26093 19.826C6.26093 19.826 9.39136 19.0918 9.39136 16.6956V12.1738H3.13049Z" fill="#D80027"/>
  <path d="M6.26242 18.3702C5.68167 18.1612 4.52173 17.6271 4.52173 16.6959V13.5654H8.00004V16.6959C8.00004 17.6302 6.84023 18.163 6.26242 18.3702Z" fill="#338AF3"/>
  <path d="M6.95653 15.3042V14.6086L6.26091 14.2607L5.56522 14.6086V15.3042L5.21741 15.6521V17.0434H7.30441V15.6521L6.95653 15.3042Z" fill="#F3F3F3"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default SintMaarten;
